import { ExpandMore, Info } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { ReactNode, useState } from 'react'

interface Props {
  title: string
  tooltip?: string
  defaultExpanded?: boolean
  children: ReactNode
  rightRender?: ReactNode
}

export const AllocationRuleAccordionWrapper = ({
  title,
  tooltip,
  rightRender,
  defaultExpanded = true,
  children,
}: Props) => {
  const [expanded, setExpanded] = useState(defaultExpanded)
  const { palette, typography } = useMinimalsTheme()

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      disableGutters
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          backgroundColor: palette.grey[200],
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiAccordionSummary-content': {
            my: 0,
          },
        }}
      >
        <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%'>
          <Stack direction='row' alignItems='center' spacing={1}>
            <Typography variant='subtitle1'>{title}</Typography>
            {tooltip && (
              <Tooltip title={tooltip} arrow onClick={e => e.stopPropagation()}>
                <Info sx={{ fontSize: typography.pxToRem(16) }} />
              </Tooltip>
            )}
          </Stack>

          {rightRender}
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>{children}</AccordionDetails>
    </Accordion>
  )
}
